import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import videogallery from "../assets/videogallery.png";
const UploadVideo = (props) => {
    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
          const file = acceptedFiles[0];
          props.onVideoUpload(file);
        }
      }, [props.onVideoUpload]);
    
      const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    
      return (
        <div {...getRootProps()} className={`image-upload-button ${isDragActive ? 'active' : ''}`}>
          <input {...getInputProps()} />
          <img className="gallery_img" src={videogallery} />
        </div>
      );
    };

export default UploadVideo;